export const VENUE_LIST = [
  {
    id: "hokuriku",
    district: "北陸",
    limitDateDisplay: "（10月2日㊎まで）",
    limitDate: "2026-10-02T23:59:59", // この時間を過ぎたらボタン無効
    venue: "金沢市文化ホール　大集会室（2階）",
    room: "（石川県金沢市高岡町15-1）",
    dateText: "2026年10月9日㊎",
    timeText: "13:10～16:30（受付開始 12:30）",
    access: "金沢駅前（東口バスターミナル）3番・8～11番のりば「南町・尾山神社」下車　徒歩約3分",
    capacity: "160名（申込多数の場合、抽選とさせていただきます）",
    participationFee: "無料（事前申込制）",
    mapUrl:
      '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3204.488198189874!2d136.6501983772636!3d36.566451572314605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5ff8337bfe640fed%3A0x7d58ba98c9d0d17f!2z6YeR5rKi5biC5paH5YyW44Ob44O844Or!5e0!3m2!1sja!2sjp!4v1769747029626!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    url: "https://nikkan-prj.com/thunder/hokuriku_g/",
  },
  {
    id: "osaka",
    district: "大阪",
    limitDateDisplay: "（5月12日㊋まで）",
    limitDate: "2026-05-12T23:59:59", // この時間を過ぎたらボタン無効
    venue: "大阪国際会議場　グランキューブ大阪（10階）",
    room: "（大阪府大阪市北区中之島5-3-51）",
    dateText: "2026年5月19日㊋",
    timeText: "13:10～16:30（受付開始 12:30）",
    access:
      "京阪電車中之島線「中之島（大阪国際会議場）駅」（2番出口）すぐ\nJR東西線「新福島駅」（3番出口）から徒歩約10分",
    capacity: "300名（申込多数の場合、抽選とさせていただきます）",
    participationFee: "無料（事前申込制）",
    mapUrl:
      '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d820.1565450348656!2d135.4862!3d34.689383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e658eb20202f%3A0xc3e1552c4163ec4!2z44Kw44Op44Oz44Kt44Ol44O844OW5aSn6ZiqKOWkp-mYquW6nOeri-Wbvemam-S8muitsOWgtO-8iQ!5e0!3m2!1sja!2sjp!4v1769746940954!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    url: "https://nikkan-prj.com/thunder/osaka_g",
  },
  {
    id: "kyusyu",
    district: "九州",
    limitDateDisplay: "（6月5日㊎まで）",
    limitDate: "2026-06-05T23:59:59", // この時間を過ぎたらボタン無効
    venue: "JR博多シティ　JR九州ホール（9階）",
    room: "（福岡県福岡市博多区博多駅中央街1-1）",
    dateText: "2026年6月12日㊎",
    timeText: "13:10～16:30（受付開始 12:30）",
    access: "JR博多駅直結",
    capacity: "300名（申込多数の場合、抽選とさせていただきます）",
    participationFee: "無料（事前申込制）",
    mapUrl:
      '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.5970515934873!2d130.4204315!3d33.58981!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x354191c7f7e15d6b%3A0xed0b7aea1c3618af!2z44CSODEyLTAwMTIg56aP5bKh55yM56aP5bKh5biC5Y2a5aSa5Yy65Y2a5aSa6aeF5Lit5aSu6KGX77yR4oiS77yR!5e0!3m2!1sja!2sjp!4v1769746970968!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    url: "https://nikkan-prj.com/thunder/kyusyu_g/",
  },
  {
    id: "tokyo",
    district: "東京",
    limitDateDisplay: "（7月16日㊍まで）",
    limitDate: "2026-07-16T23:59:59", // この時間を過ぎたらボタン無効
    venue: "東京ポートシティ竹芝　ポートホール（1階）",
    room: "（東京都港区海岸1-7-1 東京ポートシティ竹芝　オフィスタワー）",
    dateText: "2026年7月24日㊎",
    timeText: "13:10～16:30（受付開始 12:30）",
    access:
      "JR山手線、京浜東北線・根岸線、東京モノレール　浜松町駅北口より徒歩4分\n新交通ゆりかもめ線　竹芝駅　デッキ直通徒歩2分\n都営地下鉄大江戸線、都営地下鉄浅草線　大門駅　B2出口より徒歩5分",
    capacity: "300名（申込多数の場合、抽選とさせていただきます）",
    participationFee: "無料（事前申込制）",
    mapUrl:
      '<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3241.884442971998!2d139.758095!3d35.6552186!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b7e9c0d08a7%3A0xe97d025b25f3950f!2z5p2x5Lqs44Od44O844OI44K344OG44Kj56u56Iqd44Kq44OV44Kj44K544K_44Ov44O8!5e0!3m2!1sja!2sjp!4v1769746987613!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    url: "https://nikkan-prj.com/thunder/tokyo_g/",
  },
];
